// @ts-nocheck

export const formatCurrency = (
  amount: number,
): { first: number; second: number } => {
  return {
    first: Math.floor(amount / 100).toLocaleString("pt-BR"),
    second: (amount % 100).toString().padStart(2, "0"),
  };
};
